import { render } from "./Settlement.vue?vue&type=template&id=ca3aa5b0&scoped=true"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"

import "./Settlement.vue?vue&type=style&index=0&id=ca3aa5b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3aa5b0"]])

export default __exports__